module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1242x2688.99247819.png";